module.exports = __webpack_public_path__ + "img/icon_5_48.88a6756e.png";